import(/* webpackMode: "eager" */ "/codebuild/output/src1470017970/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/error.tsx");
